export function getProgressColor(percentage: number | null): string {
    if (percentage === null) return '#ccc';

    if (percentage <= 50) {
        const red = 255;
        const green = Math.round((percentage / 50) * 255);
        return `rgb(${red}, ${green}, 0)`; // red → yellow
    } else {
        const red = Math.round(255 - ((percentage - 50) / 50) * 255);
        const green = 255;
        return `rgb(${red}, ${green}, 0)`; // yellow → green
    }
}
